<template>
  <div
    v-if="BrowserService.isWideScreen()"
    class="row no-gutters pl-5 pr-5 news-grid"
  >
    <div
      v-for="(item, index) in news.slice(0, 7)"
      :key="item.id"
      :class="[index > 2 ? 'col-3 pl-3' : 'col-4', 'mb-5 pl-3 pr-3']"
    >
      <a :href="item.link">
        <div class="news-card relative overflow-hidden">
          <div class="news-card-background novelty__image mb-3 lg:mb-0">
            <div class="overflow-hidden">
              <RemoteResponsiveImage
                :product-image-data="item.image"
                img-class="image-cover w-100 h-auto"
                :alt="item.title"
                sizes="(min-width: 1200px) 620px, (min-width: 768px) 25vw, (min-width: 600px) 35vw, (min-width: 500px) 50vw, 70vw"
              />
            </div>
          </div>
          <div
            class="news-card-foreground absolute text-center flex flex-col align-middle justify-center"
            :class="index > 2 ? 'pl-3 pr-3' : 'pl-3 pr-3 xxl:pl-5 xxl:pr-5'"
          >
            <h2 class="h2 mb-2 w-100 color-primary">{{ item.title }}</h2>
            <p
              class="mb-3 text-sm relative"
              v-html="item.text"
            />
            <div class="btn btn-success  px-4 py-2 rounded-pill ml-auto mr-auto mt-1 xxl:mt-3">
              {{ t('want_to_taste') }}
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import BrowserService from '@/services/browserService'

defineProps({
  news: {
    type: Array,
    default: () => [],
  },
})

const { t } = useI18n()
</script>

<i18n>
  {
    "cs": {
    "want_to_taste": "Chci ochutnat"
},
    "sk": {
    "want_to_taste": "Chcem ochutnať"
},
    "pl": {
    "want_to_taste": "Spróbuj"
},
    "hu": {
    "want_to_taste": "Megkóstolom"
},
    "de": {
    "want_to_taste": "Jetzt probieren!"
},
    "at": {
    "want_to_taste": "Jetzt probieren!"
},
    "ro": {
    "want_to_taste": "Vreau să gust"
}
  }
</i18n>
